import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LucideIconsModule } from '../../../../../../shared/lucide-icons.module';
import { CountrySelectorComponent } from '../../../../../../shared/components/country-selector/country-selector.component';
import { bindComponentViewModel } from '../../../../../../shared/utils/component-view-model.util';

@Component({
    selector: 'app-property-create-wizard',
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, LucideIconsModule, CountrySelectorComponent],
    templateUrl: './property-create-wizard.component.html',
    styleUrls: ['./property-create-wizard.component.scss']
})
export class PropertyCreateWizardComponent {

    addLandmark: any;
    addPaymentPlan: any;
    addPaymentPlanRow: any;
    addPlanScenario: any;
    addPlanScenarioPreset: any;
    applyLandmarkPreset: any;
    areaUnits: any;
    availableFeatures: any;
    bedroomOptions: any;
    clearFloorPlan: any;
    clearLayoutImage: any;
    countryClasses: any;
    createdPropertyId: any;
    currencies: any;
    currentStep: any;
    discountOptions: any;
    distanceUnits: any;
    draftInlinePaymentPlans: any;
    error: any;
    fieldInvalid: any;
    finishingOptions: any;
    floorPlanError: any;
    floorPlanFile: any;
    floorSelectOptions: any;
    formatNumberNoDecimals: any;
    furnishOptions: any;
    generateAutoPlan: any;
    goToStep: any;
    images: any;
    inputClasses: any;
    isFeatureSelected: any;
    isUnitSecondaryBadgeDisabled: any;
    isUnitSecondaryBadgeSelected: any;
    landmarkPresets: any;
    landmarks: any;
    landmarksForm: any;
    layoutImageError: any;
    layoutImageFile: any;
    maintenanceModes: any;
    nextStep: any;
    numberOfFloorsSelectOptions: any;
    onAreaToggle: any;
    onFloorPlanSelected: any;
    onImagesSelected: any;
    onLayoutImageSelected: any;
    onProjectChange: any;
    onUnitBadgePrimaryChange: any;
    onUnitSecondaryBadgeToggle: any;
    paymentPlanRowAmountLabel: any;
    paymentPlanRows: any;
    paymentPlans: any;
    paymentPlansForm: any;
    phases: any;
    planGeneratorForm: any;
    planMode: any;
    planScenarioPreview: any;
    planScenarios: any;
    prevStep: any;
    publicPriceSource: any;
    publicPriceSourceHasIssue: any;
    publicPriceSourceHelpText: any;
    publicPriceSourceOptions: any;
    projectLocationAddress: any;
    projectLocationLink: any;
    projects: any;
    propertyForm: any;
    propertyTypeSelectOptions: any;
    removeImage: any;
    removeLandmark: any;
    removePaymentPlan: any;
    removePaymentPlanRow: any;
    removePlanScenario: any;
    resetPlanScenarios: any;
    saving: any;
    selectedCurrencyCode: any;
    selectedFeatureList: any;
    selectedFeatures: any;
    setPublicPriceSource: any;
    setMainImage: any;
    setPlanMode: any;
    paymentPlanManagerHref: any;
    setUseProjectLocation: any;
    submitAll: any;
    toggleFeature: any;
    unitBadgePrimaryOptions: any;
    unitBadgePrimaryValue: any;
    unitBadgeSecondaryLimit: any;
    unitBadgeSecondaryOptions: any;
    unitNumberRequired: any;
    useProjectLocation: any;
    validationSummary: any;
    private _vm: any;

    @Input({ required: true })
    set vm(value: any) {
        this._vm = value;
        bindComponentViewModel(this, value, ['_vm']);
    }

    get vm(): any {
        return this._vm;
    }
}
